import React from 'react';
import { Link } from 'react-router-dom';
import { checkPermissions } from '../Services/User/User';

const Dropdown = ({ dropdownTitle, dropdownclassName, collapsNav, items, isActive, menuRerander }) => {
  return (
    <li className="nav-item game-nav-link">
      <a
        className={isActive ? 'nav-link' : 'nav-link collapsed'}
        aria-expanded={isActive ? true : false}
        data-bs-target={'#' + collapsNav}
        data-bs-toggle="collapse"
        href="#"
      >
        <i className={dropdownclassName}></i>
        <span>{dropdownTitle}</span>
        <i className="bi bi-chevron-down ms-auto"></i>
      </a>
      <ul
        className={isActive ? 'nav-content collapse show' : 'nav-content collapse'}
        id={collapsNav}
        data-bs-parent="#sidebar-nav"
      >
        {items.map(({ permission_key, link, text, itemIsActive }) => {
          if (permission_key && !checkPermissions(permission_key)) {
            return null;
          }

          return (
            <li key={link || permission_key}>
              <Link
                to={link}
                className={itemIsActive === 'T' ? 'nav-link active' : 'nav-link'}
                onClick={() => menuRerander()}
              >
                <i className="bi bi-circle"></i>
                <span>{text}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </li>
  );
};

export default Dropdown;